module.exports = "<h5 class=\"h4 text-center\"><span style=\"color: #f26122!important;\">PreSco</span> - {{loggedInUser}} Adminisitration Module</h5>\n"